import React from 'react';

function formatDate(iso) {
    const d = new Date(iso);
    const now = new Date();
    const isToday = d.toDateString() === now.toDateString();

    if (isToday) {
        return d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
    }
    return d.toLocaleDateString('ru-RU', { day: '2-digit', month: 'short' });
}

function MailList({
                      mails,
                      selectedMailId,
                      onSelectMail,
                      onToggleStar,
                      searchQuery,
                      onSearchChange,
                      folderName,
                      onCompose,
                  }) {
    return (
        <section className="mail-list">
            <header className="mail-list-header">
                <div className="mail-search-wrapper">
                    <span className="search-icon">🔍</span>
                    <input
                        type="text"
                        className="mail-search"
                        placeholder="Поиск в почте..."
                        value={searchQuery}
                        onChange={(e) => onSearchChange(e.target.value)}
                    />
                    {searchQuery && (
                        <button
                            className="search-clear"
                            onClick={() => onSearchChange('')}
                            aria-label="Очистить"
                        >
                            ✕
                        </button>
                    )}
                </div>
                <div className="mail-list-title">
                    <h2>{folderName}</h2>
                    <span className="mail-count">{mails.length}</span>
                </div>
            </header>

            <div className="mail-items">
                {mails.length === 0 && (
                    <div className="mail-empty">
                        <span className="mail-empty-icon">📭</span>
                        <p>Здесь пока нет писем</p>
                        <button className="mail-empty-btn" onClick={onCompose}>
                            Написать письмо
                        </button>
                    </div>
                )}

                {mails.map(mail => (
                    <div
                        key={mail.id}
                        className={`mail-item ${mail.read ? '' : 'unread'} ${selectedMailId === mail.id ? 'selected' : ''}`}
                        onClick={() => onSelectMail(mail.id)}
                    >
                        <div className="mail-item-avatar">
                            {mail.from.avatar}
                        </div>

                        <div className="mail-item-body">
                            <div className="mail-item-top">
                                <span className="mail-item-from">
                                    {mail.from.name}
                                </span>
                                <span className="mail-item-date">
                                    {formatDate(mail.date)}
                                </span>
                            </div>
                            <div className="mail-item-subject">
                                {mail.subject}
                            </div>
                            <div className="mail-item-preview">
                                {mail.preview}
                            </div>
                            {mail.labels.length > 0 && (
                                <div className="mail-item-labels">
                                    {mail.labels.map(l => (
                                        <span
                                            key={l}
                                            className={`mail-label label-${l}`}
                                        />
                                    ))}
                                </div>
                            )}
                        </div>

                        <div className="mail-item-actions">
                            <button
                                className={`star-btn ${mail.starred ? 'starred' : ''}`}
                                onClick={(e) => onToggleStar(mail.id, e)}
                                aria-label="Пометить"
                            >
                                {mail.starred ? '★' : '☆'}
                            </button>
                            {mail.attachments.length > 0 && (
                                <span className="attach-icon">📎</span>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default MailList;